<template>
  <div>
    <div
      class="select-auth-type-wrapper"
      v-if="currentPage == pageNames.authSelectPage"
    >
      <img class="auth-bg" src="../assets/background-image.jpg" />
      <AuthSelectPage class="auth-content" @openNextPage="openInputInnPage" />
    </div>
    <div v-else class="mainWrapper">
      <loading :active.sync="isLoading" :is-full-page="false"></loading>
      <div class="body">
        <img class="body-logo" src="../assets/o-logo.png" />
        <HeaderWithTip
          class="body-header-tip"
          :label="headerTip"
          v-if="
            currentPage != '' && currentPage != 'next' && currentPage != 'back'
          "
        />
        <div class="loading-server">
          <LoadingFromServer v-if="statusLoading" />
        </div>
        <div class="content" v-show="!statusLoading">
          <MainCounteragents
            v-if="currentPage == 'main_counteragents'"
            :pageName="currentPage"
            :bankName="bankName"
            :pageInfo="pageInfo"
            :url="url"
            @changePageSendData="pageSendData"
            @enableButtons="enableButtons"
            @updated="isChanged = true"
          />
          <InputINN
            class="inn"
            v-if="currentPage == pageNames.inn"
            @validate="enableButtons"
            @changePageSendData="pageSendData"
            @enableButtons="enableButtons"
            :pageInfo="pageInfo"
            :hasEsia="!esiaINN"
            :userINN="INN"
            :url="mainUrl"
            :bankName="bankName"
            :innArray="innArray"
            :withDigitalKey="withDigitalKey"
          />
          <PlanOperations
            v-if="currentPage == 'planning_operations_info'"
            :bankName="bankName"
            :pageName="currentPage"
            :pageInfo="pageInfo"
            :url="url"
            @changePageSendData="pageSendData"
            @enableButtons="enableButtons"
            @updated="isChanged = true"
          />
          <LisOfAnotherBanks
            v-if="currentPage == 'list_of_another_banks'"
            :bankName="bankName"
            :pageName="currentPage"
            :currentBankBik="currentBankBik"
            :pageInfo="pageInfo"
            :url="url"
            @changePageSendData="pageSendData"
            @enableButtons="enableButtons"
            @updated="isChanged = true"
          />

          <PrivacyPolicy
            class="pricPol"
            v-if="currentPage == 'privacy_policy'"
            :pageInfo="pageInfo"
            :pageName="currentPage"
            :bankName="bankName"
            @changePageSendData="pageSendData"
            @enableButtons="enableButtons"
            @updated="isChanged = true"
          />
          <CompanyInformation
            v-if="currentPage == 'general_info_with_statcodes'"
            :bankName="bankName"
            :pageName="currentPage"
            :pageInfo="pageInfo"
            @changePageSendData="pageSendData"
            @enableButtons="enableButtons"
            @updated="isChanged = true"
          />
          <IpInformation
            v-if="currentPage == 'general_info_with_statcodes_ip'"
            :bankName="bankName"
            :pageName="currentPage"
            :pageInfo="pageInfo"
            :url="url"
            @changePageSendData="pageSendData"
            @enableButtons="enableButtons"
            @updated="isChanged = true"
          />
          <BeneficiaryList
            v-if="currentPage == 'beneficiary_list'"
            :url="url"
            :bankName="bankName"
            :pageName="currentPage"
            :pageInfo="pageInfo"
            @changePageSendData="pageSendData"
            @enableButtons="enableButtons"
            @updated="isChanged = true"
          />
          <BeneficiaryListIP
            v-if="currentPage == 'beneficiary_list_ip'"
            :url="url"
            :bankName="bankName"
            :pageName="currentPage"
            :pageInfo="pageInfo"
            @changePageSendData="pageSendData"
            @enableButtons="enableButtons"
            @updated="isChanged = true"
          />
          <RelationshipWithBank
            v-if="currentPage == 'aims_of_relationships_with_bank'"
            :bankName="bankName"
            :pageName="currentPage"
            @changePageSendData="pageSendData"
            @enableButtons="enableButtons"
            @updated="isChanged = true"
            :pageInfo="pageInfo"
          />
          <FinancialPosition
            v-if="currentPage == 'financial_position'"
            :pageName="currentPage"
            :bankName="bankName"
            :pageInfo="pageInfo"
            :isIP="isIP"
            @changePageSendData="pageSendData"
            @enableButtons="enableButtons"
            @updated="isChanged = true"
          />
          <NeedECP
            v-if="currentPage == 'need_eds'"
            :pageName="currentPage"
            :pageInfo="pageInfo"
            :url="url"
            @isLoading="changeLoading"
            @nextStep="nextStep"
            @changePageSendData="pageSendData"
            @enableButtons="enableButtons"
          />
          <ReputationInfo
            v-if="currentPage == 'reputation_info'"
            :pageName="currentPage"
            :pageInfo="pageInfo"
            :isIP="isIP"
            @changePageSendData="pageSendData"
            @enableButtons="enableButtons"
            @updated="isChanged = true"
            :bankName="bankName"
            :finPosition="finPosition"
          />
          <CompanyHasSovet
            v-if="currentPage == 'org_structure_ext_info'"
            :pageName="currentPage"
            :bankName="bankName"
            :pageInfo="pageInfo"
            @changePageSendData="pageSendData"
            @enableButtons="enableButtons"
            @updated="isChanged = true"
          />
          <IpHasSovet
            v-if="currentPage == 'org_structure_ext_info_ip'"
            :pageName="currentPage"
            :bankName="bankName"
            :pageInfo="pageInfo"
            @changePageSendData="pageSendData"
            @enableButtons="enableButtons"
            @updated="isChanged = true"
          />
          <BossInfo
            v-if="currentPage == 'boss_list'"
            :chairmen="chairmen"
            :url="url"
            :pageName="currentPage"
            :bankName="bankName"
            :pageInfo="pageInfo"
            @changePageSendData="pageSendData"
            @enableButtons="enableButtons"
            @updated="isChanged = true"
          />
          <FoundersList
            v-if="currentPage == 'founder_list'"
            :pageName="currentPage"
            :bankName="bankName"
            :pageInfo="pageInfo"
            :url="url"
            @changePageSendData="pageSendData"
            @enableButtons="enableButtons"
            @updated="isChanged = true"
          />
          <EntitiesFounderInfo
            v-if="currentPage == 'entity_founder_list'"
            :pageName="currentPage"
            :bankName="bankName"
            :pageInfo="pageInfo"
            @changePageSendData="pageSendData"
            @enableButtons="enableButtons"
            @updated="isChanged = true"
          />
          <FatcaAgreement
            v-if="currentPage == 'fatca_agreement'"
            :pageName="currentPage"
            :bankName="bankName"
            :pageInfo="pageInfo"
            @changePageSendData="pageSendData"
            @enableButtons="enableButtons"
            @updated="isChanged = true"
          />
          <FatcaAgreementIP
            v-if="currentPage == 'fatca_agreement_ip'"
            :pageName="currentPage"
            :bankName="bankName"
            :pageInfo="pageInfo"
            @changePageSendData="pageSendData"
            @enableButtons="enableButtons"
            @updated="isChanged = true"
          />
          <AnotherFacesAgree
            v-if="currentPage == 'another_faces_agree'"
            :pageName="currentPage"
            :bankName="bankName"
            :pageInfo="pageInfo"
            :url="url"
            :isIP="isIP"
            @changePageSendData="pageSendData"
            @enableButtons="enableButtons"
            @updated="isChanged = true"
          />
          <TakeFinalInformation
            v-if="
              currentPage == 'client_info_credital_info_stuff_share_info_agree'
            "
            :pageName="currentPage"
            :bankName="bankName"
            :pageInfo="pageInfo"
            :isIP="isIP"
            @changePageSendData="pageSendData"
            @enableButtons="enableButtons"
            @updated="isChanged = true"
          />
          <KnowAboutBank
            v-if="currentPage == 'where_know_about_bank'"
            :pageName="currentPage"
            :bankName="bankName"
            :pageInfo="pageInfo"
            @changePageSendData="pageSendData"
            @enableButtons="enableButtons"
            @updated="isChanged = true"
          />
          <AnotherLocationDocs
            v-if="
              currentPage ==
                'company_strategy_position_and_another_location_docs'
            "
            :pageName="currentPage"
            :bankName="bankName"
            :pageInfo="pageInfo"
            :isIP="isIP"
            @changePageSendData="pageSendData"
            @enableButtons="enableButtons"
            @updated="isChanged = true"
          />
          <AnotherLocationDocsIp
            v-if="
              currentPage ==
                'company_strategy_position_and_another_location_docs_ip'
            "
            :pageName="currentPage"
            :bankName="bankName"
            :pageInfo="pageInfo"
            :isIP="isIP"
            @changePageSendData="pageSendData"
            @enableButtons="enableButtons"
            @updated="isChanged = true"
          />
          <AgreementKinds
            v-if="currentPage == 'tax_mode_and_agreement_kinds'"
            :pageName="currentPage"
            :bankName="bankName"
            :pageInfo="pageInfo"
            @changePageSendData="pageSendData"
            @enableButtons="enableButtons"
            @updated="isChanged = true"
          />
          <EgrulInfoMain
            v-if="currentPage == 'egrul_info_main'"
            :pageName="currentPage"
            :bankName="bankName"
            :pageInfo="pageInfo"
            :isIP="isIP"
            @changePageSendData="pageSendData"
            @enableButtons="enableButtons"
            @updated="isChanged = true"
          />
          <MainDocs
            v-if="currentPage == 'main_docs'"
            :pageName="currentPage"
            :bankName="bankName"
            :pageInfo="pageInfo"
            @changePageSendData="pageSendData"
            @enableButtons="enableButtons"
            @updated="isChanged = true"
          />
          <LastName v-if="currentPage == 'last_page'" :bankName="bankName" />
          <NegativeAnswerPage
            v-if="currentPage == 'negative_answer'"
            :pageInfo="pageInfo"
            @tryAgain="tryNewQuestionary"
          />
          <PositiveAnswerPage v-if="currentPage == 'positive_answer'" />
          <NotValidVersion
            v-if="currentPage == 'unvalid_version'"
            :url="mainUrl"
            :pageInfo="pageInfo"
          />
          <AppInTestMode v-if="currentPage == 'app_in_test_mode'" />
        </div>
        <div class="footer">
          <FooterButtons
            :nextButtonLabel="
              currentPage == 'need_eds'
                ? 'Отправить информацию в банк'
                : 'Далее'
            "
            :backButton="backButton"
            :nextButton="nextButton"
            :msg="errorMsg"
            :remarkMsg="remarkMsg"
            @on_click_back="backStep"
            @on_click_next="nextStep"
            v-if="
              currentPage != 'last_page' &&
                currentPage != 'unvalid_version' &&
                currentPage != 'negative_answer' &&
                currentPage != 'positive_answer' &&
                currentPage != 'app_in_test_mode' &&
                currentPage != pageNames.authSelectPage &&
                !statusLoading &&
                !isLoading
            "
          />
          <div class="version">{{ "v." + version }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderWithTip from "./parts/v-header-tip.vue";
import AuthSelectPage from "./v-auth-select-page.vue";
import InputINN from "./v-input-inn.vue";
import FooterButtons from "./parts/v-footer-buttons.vue";
import PrivacyPolicy from "./v-privacy-policy.vue";
import CompanyInformation from "./v-company-information.vue";
import IpInformation from "./v-ip-information.vue";
import BeneficiaryList from "./v-beneficiary-list.vue";
import BeneficiaryListIP from "./v-beneficiary-list-ip.vue";
import RelationshipWithBank from "./v-aim-of-relationship-with-bank.vue";
import LisOfAnotherBanks from "./v-list-of-another-banks.vue";
import PlanOperations from "./v-plan-operations.vue";
import NeedECP from "./v-need-ecp.vue";
import LoadingFromServer from "./v-loading-server.vue";
import MainCounteragents from "./v-main-counteragents.vue";
import FinancialPosition from "./v-financial-position.vue";
import ReputationInfo from "./v-reputation-info.vue";
import CompanyHasSovet from "./v-has-consul.vue";
import IpHasSovet from "./v-has-consul-ip.vue";
import BossInfo from "./v-boss-info.vue";
import FoundersList from "./v-founders-list.vue";
import EntitiesFounderInfo from "./v-entities-founder.vue";
import FatcaAgreement from "./v-fatca-agreement.vue";
import FatcaAgreementIP from "./v-fatca-agreement-ip.vue";
import AnotherFacesAgree from "./another-face-agree/v-another-faces-agree.vue";
import TakeFinalInformation from "./v-take-final-info-agree.vue";
import KnowAboutBank from "./v-know-about-bank.vue";
import LastName from "./v-last-page.vue";
import PositiveAnswerPage from "./v-positive-answer.vue";
import NegativeAnswerPage from "./v-negative-answer.vue";
import AgreementKinds from "./v-agreement-kind.vue"; // + tax types1
import EgrulInfoMain from "./v-egrul-info-main.vue";
import MainDocs from "./v-main-docs.vue";
import AnotherLocationDocs from "./v-another-location-docs.vue";
import AnotherLocationDocsIp from "./v-another-location-docs-ip.vue";
import NotValidVersion from "./v-unvalid-version.vue";
import AppInTestMode from "./v-test-mode-app.vue";
import Loading from "vue-loading-overlay";

import "vue-loading-overlay/dist/vue-loading.css";
import Axios from "axios";

export default {
  name: "MainWrapper",
  components: {
    HeaderWithTip,
    AuthSelectPage,
    InputINN,
    FooterButtons,
    PrivacyPolicy,
    CompanyInformation,
    IpInformation,
    NotValidVersion,
    BeneficiaryList,
    BeneficiaryListIP,
    RelationshipWithBank,
    LisOfAnotherBanks,
    PlanOperations,
    LoadingFromServer,
    MainCounteragents,
    FinancialPosition,
    ReputationInfo,
    NeedECP,
    CompanyHasSovet,
    IpHasSovet,
    BossInfo,
    FoundersList,
    EntitiesFounderInfo,
    FatcaAgreement,
    FatcaAgreementIP,
    AnotherFacesAgree,
    TakeFinalInformation,
    KnowAboutBank,
    LastName,
    NegativeAnswerPage,
    PositiveAnswerPage,
    AgreementKinds,
    EgrulInfoMain,
    MainDocs,
    AnotherLocationDocs,
    AnotherLocationDocsIp,
    AppInTestMode,
    Loading,
  },
  data() {
    return {
      bankName: "ПАО «РосДорБанк»",
      msg: {},
      headerTip: "",
      INN: "",
      esiaINN: false,
      errorMsg: "",
      remarkMsg: "",
      innArray: [],
      isLoading: false,
      version: "1.1.0",
      finPosition: 0,
      mainUrl: "",
      url: "",
      mainInfo: {},
      continueToken: "",
      test: "",
      backButton: true,
      nextButton: true,
      isIP: false,
      companyInf: {},
      currentBankBik: "",
      step: 4,
      index: 1,
      currentPage: "",
      pageInfo: {},
      statusLoading: false,
      isChanged: false,
      sendData: {},
      isFormData: false,
      withDigitalKey: false,
      chairmen: [],
      innHeaderTip: "Заявка шаг 1",
      authSelectHeaderTip: "Выберите способ входа",
      pageNames: {
        authSelectPage: "auth_select",
        inn: "inn",
      },
    };
  },
  async created() {
    // this.mainUrl = "http://185.48.39.115:8089";
    // this.mainUrl = "https://welcome.rdb.ru/";
   // this.mainUrl = location.origin;

    var dev = false;
    if (dev)
      this.mainUrl = "http://185.48.39.115:8089";
    else this.mainUrl = location.origin;

    console.log("Main URL : " + this.mainUrl);
    this.url = this.mainUrl + "/idrdb/api/v1/questionnaire/";
    console.log("FULL url:" + this.url);
    this.isLoading = true;
    this.getCurrentBankBik();
    if (await this.checkVersion()) {
      this.headerTip = this.authSelectHeaderTip;
      //await this.getEsia();
      this.currentPage = this.pageNames.authSelectPage;
    } else {
      this.currentPage = "unvalid_version";
    }
    await this.getInnFromUrl();
    this.isLoading = false;
  },
  methods: {
    async getEsia() {
      try {
        let response = await Axios.get("/idrdb/esia?getinn=1", {
          headers: {
            "Content-Type": "application/json;charset=utf-8",
          },
        });
        let js = response.data;
        if (js.INN != null && js.INN.length > 0) {
          this.INN = js.INN;
          this.esiaINN = true;
        }
      } catch (error) {
        this.$alert("Не удалось получить данные с ЕСИА");
        console.log(error);
      }
    },
    async getInnFromUrl() {
      const params = new URLSearchParams(window.location.search);
      let inn = params.get("inn");
      if (inn == null) inn = params.get("INN");
      if (
        inn != null &&
        (inn.length == 10 || inn.length == 12) &&
        !isNaN(inn) &&
        inn.indexOf(".") == -1
      ) {
        this.sendData = {
          INN: inn,
        };
        await this.sendToServerNext();
      }
    },
    async checkVersion() {
      try {
        let response = await fetch(this.url + "test_version", {
          method: "POST",
          headers: {
            "Content-Type": "application/json;charset=utf-8",
          },
          body: JSON.stringify({ VERSION: this.version }),
        });
        if (response.status == 409) {
          this.pageInfo = await response.json();
          return false;
        } else return true;
      } catch (error) {
        console.log(error);
      }
      return true;
    },
    inputMainInfo(data) {
      this.mainInfo = data;
    },
    async getCurrentBankBik() {
      let bik = await Axios.get(this.url + "get_current_bank_bik", {});
      this.currentBankBik = bik.data;
    },
    changeLoading(isLoading) {
      this.isLoading = isLoading;
    },
    async tryNewQuestionary(sendData) {
      try {
        await this.serverMethodPost("post_negative_answer", sendData);
        this.INN = sendData.INN;
        this.currentPage = this.pageNames.inn;
        this.headerTip = this.innHeaderTip;
      } catch (e) {
        console.log(e);
      }
    },
    pageSendData(sendData, isFormData) {
      this.sendData = sendData;
      this.isFormData = isFormData;
    },
    enableButtons(backButton, msg) {
      this.nextButton = msg.length == 0;
      this.errorMsg = msg;
    },
    openInputInnPage(withDigitalKey) {
      this.withDigitalKey = withDigitalKey;
      this.currentPage = this.pageNames.inn;
      this.headerTip = this.innHeaderTip;
    },
    async nextStep() {
      this.backButton = true;
      await this.sendToServerNext();
      this.isChanged = false;
    },
    async backStep() {
      if (this.currentPage == this.pageNames.inn) {
        this.currentPage = this.pageNames.authSelectPage;
        this.headerTip = this.authSelectHeaderTip;
      } else if (this.isChanged) {
        this.$fire({
          text:
            'При нажатии кнопки "Назад" все введенные и измененные данные с этой страницы будут потеряны! Продолжить?',
          showCancelButton: true,
          confirmButtonColor: "#06569b",
          cancelButtonColor: "red",
          confirmButtonText: "Да",
          cancelButtonText: "Нет",
        }).then(async (result) => {
          if (result.value != null) {
            this.sendData = {};
            await this.sendToServerBack();
            this.isChanged = false;
          }
        });
      } else {
        this.sendData = {};
        await this.sendToServerBack();
        this.isChanged = false;
      }
    },
    async sendToServerBack() {
      this.isLoading = true;
      let a = await this.serverMethodPost("get_back", {
        CURRENT_PAGE: this.currentPage,
        INN: this.pageInfo.INN,
        ID: this.pageInfo.ID,
        CONTINUE_TOKEN: this.pageInfo.CONTINUE_TOKEN,
        UPDATE_DATE: this.pageInfo.UPDATE_DATE,
      });
      if (a.PREV_SCREEN_NAME != null)
        await this.sendToServerGet(a.PREV_SCREEN_NAME);
    },
    logArrToConsole(ar, t) {
      let a = "[ ";
      ar.forEach((e) => (a += e + " "));
      if (t) {
        a = a.replace("INN ", "");
        a = a.replace("ID ", "");
        a = a.replace("FILES ", "");
      }
      a += "]";
      return a;
    },
    fillMainInfo(data) {
      this.mainInfo.INN = data.INN;
      this.mainInfo.ID = data.ID;
      this.mainInfo.CONTINUE_TOKEN = this.continueToken;
    },
    async sendToServerNext() {
      this.isLoading = true;
      var sendData = this.sendData;
      if (this.currentPage == this.pageNames.inn) {
        sendData.LAST_SCREEN_NAME = this.pageNames.inn;
        this.continueToken = sendData.CONTINUE_TOKEN;
        let a = await this.serverMethodPost("start_questionarie", sendData);
        this.fillMainInfo(a);
        this.isIP = a.Q_KIND == "IP";
        if (a.NEXT_SCREEN_NAME != null) {
          await this.sendToServerGet(a.NEXT_SCREEN_NAME);
        }
      } else if (this.isFormData) {
        var files = sendData.FILES;
        var filesIsOk = true;
        var a;
        if (files != null)
          for (let i = 0; i < files.length; i++) {
            if (files[i].CAPTION.length == 0) continue;
            let formData = new FormData();
            formData.append("INN", sendData.INN);
            formData.append("ID", sendData.ID);
            formData.append("CONTINUE_TOKEN", this.continueToken);
            formData.append("UPDATE_DATE", sendData.UPDATE_DATE);
            formData.append("INSERT_METHOD_NAME", this.currentPage);
            formData.append("FILE_CAPTION", files[i].CAPTION);
            formData.append("file_data", files[i].FILE);
            if (files[i].FILE != null)
              formData.append("file_name", files[i].FILE.name);
            a = await this.serverMethodForm("attach_file", formData);
            filesIsOk = filesIsOk && !a.error;
          }
        if (filesIsOk) {
          delete sendData.FILES;
          await this.sendInfoAndFetchNewScreenInfo(sendData);
        }
      } else {
        await this.sendInfoAndFetchNewScreenInfo(sendData);
      }
    },
    async sendInfoAndFetchNewScreenInfo(sendData) {
      let a;
      sendData.LAST_SCREEN_NAME = this.currentPage;
      sendData.CONTINUE_TOKEN = this.continueToken;
      a = await this.serverMethodPost("post_" + this.currentPage, sendData);
      this.fillMainInfo(a);
      if (a.NEXT_SCREEN_NAME != null)
        await this.sendToServerGet(a.NEXT_SCREEN_NAME);
    },

    async sendToServerGet(name) {
      let a;
      this.remarkMsg = "";
      if (
        name != null &&
        name != "unvalid_version" &&
        name != "app_in_test_mode" &&
        name != "positive_answer" &&
        name != this.pageNames.inn
      ) {
        if (name == "last_page")
          a = await this.serverMethodGet(
            "get_questionnaire_commit",
            this.mainInfo
          );
        else a = await this.serverMethodGet("get_" + name, this.mainInfo);
        if (a != null) {
          if (a.DECLINE_INFO != null)
            a.DECLINE_INFO.forEach((element) => {
              this.remarkMsg += "● " + element + "<br>";
            });
          this.pageInfo = a;
          if (name != "negative_answer")
            this.headerTip = await this.getHeadTip(name);
          else this.headerTip = "";
          this.currentPage = name;
        }
      } else {
        if (name != null) {
          if (name != this.pageNames.inn)
            this.headerTip = await this.getHeadTip(name);
          else if (
            name == "negative_answer" ||
            name == "positive_answer" ||
            name == "unvalid_version"
          )
            this.headerTip = "";
          else this.headerTip = this.innHeaderTip;
          this.currentPage = name;
        } else {
          this.$alert("Ошибка получения названия следующей страницы");
          this.headerTip = this.innHeaderTip;
          this.currentPage = this.pageNames.inn;
        }
      }
      this.isLoading = false;
    },
    async getHeadTip(name) {
      try {
        let response = await fetch(this.url + "get_current_screen_caption", {
          method: "POST",
          headers: {
            "Content-Type": "application/json;charset=utf-8",
          },
          body: JSON.stringify({
            CURRENT_SCREEN_NAME: name,
            ID: this.pageInfo.ID,
            INN: this.pageInfo.INN,
          }),
        });
        let json = await response.json();
        return json.SCREEN_CAPTION;
      } catch (error) {
        if (name == this.pageNames.inn) return this.innHeaderTip;
        else return "";
      }
    },
    async serverMethodPost(url, sendData) {
      var data = {};
      var errorMsg;
      var a;
      // console.log(url);
      // console.log(sendData);
      sendData.VERSION = this.version;
      try {
        let response = await fetch(this.url + url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json;charset=utf-8",
          },
          body: JSON.stringify(sendData),
        });
        if (response.status == 403) {
          a = await response.json();
          errorMsg = a.ERROR_MSG;
          data = { NEXT_SCREEN_NAME: this.pageNames.inn };
          throw new Error("Статус 403");
        }
        if (
          response.status == 406 &&
          this.currentPage == "planning_operations_info"
        ) {
          a = await response.json();
          errorMsg = a.ERROR_MSG;
          throw new Error("Статус 406");
        } else if (response.status == 521) {
          this.pageInfo = await response.json();
          errorMsg = "0";
          data = { NEXT_SCREEN_NAME: "app_in_test_mode" };
          throw new Error("Ошибка");
        } else if (response.status >= 500 && response.status < 600) {
          errorMsg = "Критическая ошибка на сервере";
          data = { NEXT_SCREEN_NAME: this.pageNames.inn };
          throw new Error("Статус 500");
        } else if (response.status == 409) {
          this.pageInfo = await response.json();
          errorMsg = "0";
          this.currentPage = "unvalid_version";
          throw new Error("Статус 409");
        } else if (response.status == 200) {
          let json = await response.json();
          return json;
        } else if (response.status == 404) {
          errorMsg = "Сервер не найден";
          throw new Error("Статус 404");
        } else if (response.status == 423) {
          errorMsg =
            "Временные проблемы на сервере. Подождите немного и повторите отправку";
          throw new Error("Статус 423");
        } else {
          errorMsg = "Неизвестная ошибка";
          throw new Error("Статус " + response.status);
        }
      } catch (error) {
        this.isLoading = false;
        console.log(error);
        if (errorMsg != null && errorMsg != "0") this.$alert(errorMsg);
        else {
          if (errorMsg != "0")
            this.$alert(
              "Ошибка соединения с сервером. Попробуйте повторить попытку позже."
            );
        }
        data.INN = sendData.INN;
        data.ID = sendData.ID;
        return data;
      }
    },
    async serverMethodGet(url, sendData) {
      var errorMsg;
      try {
        let status = 204;
        sendData.VERSION = this.version;
        while (status == 204) {
          let response = await fetch(this.url + url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json;charset=utf-8",
            },
            body: JSON.stringify(sendData),
          });

          if (response.status == 204) {
            this.statusLoading = true;
            this.isLoading = false;
            status = 204;
            await this.sleep();
          } else if (response.status == 200) {
            this.statusLoading = false;
            status = 200;
            let json = await response.json();
            // console.log(url);
            // console.log(json);
            return json;
          } else if (response.status == 406) {
            let json = await response.json();
            if (json.BadINN != null && json.BadINN.length > 0) {
              errorMsg = "Указанный ИНН " + json.BadINN + " не существует";
            }
            this.headerTip = this.innHeaderTip;
            this.currentPage = this.pageNames.inn;
            throw new Error("Ошибка");
          } else if (response.status == 409) {
            this.pageInfo = await response.json();
            errorMsg = "0";
            this.currentPage = "unvalid_version";
            throw new Error("Ошибка");
          } else if (response.status == 404) {
            errorMsg = "Сервер не найден";
            this.currentPage = this.pageNames.authSelectPage;
            this.headerTip = this.authSelectHeaderTip;
            throw new Error("Статус 404");
          } else if (response.status == 423) {
            let json = await response.json();
            errorMsg =
              json.ERROR_MSG != null
                ? json.ERROR_MSG
                : "Временные проблемы на сервере. Подождите немного и повторите отправку";
            throw new Error("Статус 423");
          } else if (response.status == 521) {
            this.pageInfo = await response.json();
            errorMsg = "0";
            this.currentPage = "app_in_test_mode";
            throw new Error("Ошибка");
          } else if (response.status >= 500 && response.status < 600) {
            errorMsg = "Критическая ошибка на сервере";
            this.currentPage = this.pageNames.authSelectPage;
            this.headerTip = this.authSelectHeaderTip;
            throw new Error("Статус 500");
          } else {
            errorMsg = "Неизвестная ошибка";
            this.headerTip = this.authSelectHeaderTip;
            this.currentPage = this.pageNames.authSelectPage;
            throw new Error("Ошибка");
          }
          await this.sleep(3000);
        }
      } catch (error) {
        if (errorMsg != null && errorMsg != "0") this.$alert(errorMsg);
        else {
          if (errorMsg != "0")
            this.$alert(
              "Ошибка соединения с сервером. Попробуйте повторить попытку позже."
            );
        }
        console.log(error);
      }
      this.isLoading = false;
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async serverMethodForm(url, sendData) {
      var errorMsg = "";
      // console.log("FILE ATTACHED");
      try {
        var response = await Axios.post(this.url + url, sendData, {
          headers: {
            "Content-Type": "multipart/form-data;",
          },
        }).catch((err) => {
          if (err.response.status == 403) {
            var a = err.response.data;
            errorMsg = a.ERROR_MSG;
            this.currentPage = this.pageNames.inn;
            this.headerTip = this.innHeaderTip;
            throw new Error("Статус 403");
          } else if (err.response.status >= 500 && err.response.status < 600) {
            errorMsg = "Критическая ошибка на сервере";
            this.headerTip = this.innHeaderTip;
            throw new Error("Статус 500");
          } else if (err.response.status == 409) {
            errorMsg = "0";
            this.currentPage = "unvalid_version";
            throw new Error("Статус 409");
          } else if (err.response.status == 404) {
            errorMsg = "Сервер не найден";
            throw new Error("Статус 404");
          } else if (err.response.status == 423) {
            errorMsg =
              "Временные проблемы на сервере. Подождите немного и повторите отправку";
            throw new Error("Статус 423");
          } else {
            errorMsg = "Неизвестная ошибка";
            throw new Error("Статус " + response.status);
          }
        });
        return { error: false };
      } catch (error) {
        this.isLoading = false;
        console.log(error);
        if (errorMsg != null && errorMsg.length > 2) this.$alert(errorMsg);
        else {
          if (errorMsg != "0")
            this.$alert(
              "Ошибка соединения с сервером. Попробуйте повторить попытку позже."
            );
        }
        return { error: true };
      }
    },
  },
};
</script>

<style>
body {
  height: 100%;
}
#app > div {
  height: 100%;
}
.select-auth-type-wrapper {
  min-width: 1050px;
  min-height: 800px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}
.auth-bg {
  opacity: 0.5;
  position: absolute;
  left: 0;
  top: 0;
  margin: 0;
  width: 100%;
  height: 100%;
}
.auth-content {
  position: relative;
}
.mainWrapper {
  font-family: Verdana, Geneva, sans-serif;
  font-size: 11pt;
  -webkit-font-smoothing: antialiased;
  text-align: center;
  -moz-osx-font-smoothing: grayscale;
  background-color: rgb(245, 245, 245);
  width: 100%;
  min-height: 100%;
  position: relative;
}
img {
  margin-top: 15px;
  margin-left: 5px;
  padding: 0;
  text-align: left;
}
.footer {
  position: absolute;
  text-align: center;
  padding-bottom: 10px;
  padding-left: 0px;
  padding-right: 0px;
  min-height: 44px;
  bottom: 0;
  width: 100%;
}
.body {
  margin: 0 auto;
  background-color: white;
  min-height: 100vh;
  width: 60%;
  min-width: 820px;
  position: relative;
}
.necessary-field {
  color: red;
  text-align: center;
}
.bold-text {
  font-weight: bold;
}
input[type="file"] {
  font-family: Verdana, Geneva, sans-serif;
}
.body-logo {
  width: 300px;
}
textarea,
textarea:disabled,
.input-line,
.input-line:disabled,
input[type="text"],
input[type="text"]:disabled {
  font-family: Verdana, Geneva, sans-serif;
  color: #333333;
  font-size: 11pt;
}
textarea:disabled,
.input-line:disabled,
input[type="text"]:disabled {
  border: 1px #cccccc solid;
  background: #dddddd;
  border-radius: 6px;
}
.necessary-bold {
  font-weight: bold;
}
.unvalid-field {
  color: red;
  font-size: 15px;
}
.valid-field {
  color: rgb(28, 231, 28);
  font-size: 15px;
}
.necessary-table-ok {
  text-align: center;
  color: rgb(28, 231, 28);
  font-size: 12px;
}
.necessary-table-not {
  text-align: center;
  color: red;
  font-size: 12px;
}
.necessary-table {
  text-align: center;
  color: black;
  font-size: 12px;
}
.tooltip {
  background-color: white;
  padding: 5px 10px;
  border: 1px red solid;
  margin-bottom: 10px;
  color: red;
  border-radius: 6px;
}
.file-name-icon {
  cursor: pointer;
}
.file-name {
  text-align: center;
  position: relative;
  padding: 5px 15px 5px 5px;
  border: 1px solid black;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 250px;
}
.necessary-message {
  color: red;
  font-size: 12px;
}
.invalid-data {
  text-align: center;
}
.invalid-data-textarea {
  margin-top: 5px;
  margin-bottom: 5px;
  resize: vertical;
  border: 1px solid #cccccc;
  border-radius: 6px;
  width: 60%;
  min-height: 35px;
}
.textarea-input {
  resize: vertical;
  border: 1px solid #cccccc;
  border-radius: 6px;
  width: 100%;
  min-height: 35px;
}
.content,
.body-header-tip {
  margin: 0 30px;
}
.content {
  padding-bottom: 70px;
}
.version {
  position: absolute;
  top: 0;
  right: 0;
  padding-right: 10px;
  padding-top: 35px;
  font-size: 10px;
}
.checkboxes {
  display: flex;
  flex-direction: column;
}
.checkboxes-row {
  display: flex;
  flex-direction: row;
}
</style>
